import { Outlet, NavLink, useNavigate } from "react-router-dom";

const NAV = [
  { path: "/admin/",               label: "Dashboard",           icon: "⊞"  },
  { path: "/admin/users",          label: "Manage Users",        icon: "👥"  },
  { path: "/admin/products",       label: "Manage Products",     icon: "🕯️" },
  { path: "/admin/orders",         label: "Manage Orders",       icon: "📦"  },
  { path: "/admin/categories",     label: "Manage Categories",   icon: "📂"  },
  { path: "/admin/customizations", label: "Customizations",      icon: "🎨"  },
  { path: "/admin/reports",        label: "Reports",             icon: "📊"  },
  { path: "/admin/archives",       label: "Archives",            icon: "🗂️" },
  { path: "/admin/settings",       label: "General Settings",    icon: "⚙️"  },
];

export default function AdminLayout() {
  const navigate  = useNavigate();
  const adminUser = JSON.parse(localStorage.getItem("admin_user") || "{}");

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    navigate("/admin/login");
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f5f2ed", fontFamily: "Georgia, serif" }}>

      {/* ── Sidebar ── */}
      <div style={{ width: "220px", flexShrink: 0, background: "#fff", borderRight: "1px solid #f0ebe3", display: "flex", flexDirection: "column", position: "sticky", top: 0, height: "100vh" }}>

        {/* Brand */}
        <div style={{ padding: "20px 20px 16px", borderBottom: "1px solid #f0ebe3" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img
              src="/logo.jpeg"
              alt="SJ Aroma Candles"
              style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "50%", flexShrink: 0 }}
            />
            <div>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "700", color: "#1a1a1a", letterSpacing: "0.06em", display: "block" }}>AROMA CANDLES</span>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#aaa", letterSpacing: "0.04em" }}>Admin Panel</span>
            </div>
          </div>
        </div>

        {/* Nav */}
        <div style={{ flex: 1, padding: "16px 12px", overflowY: "auto" }}>
          <p style={{ fontFamily: "Georgia, serif", fontSize: "9px", fontWeight: "700", color: "#bbb", letterSpacing: "0.12em", textTransform: "uppercase", padding: "0 8px", marginBottom: "8px" }}>Main Menu</p>

          {NAV.map(({ path, label, icon }) => (
            <NavLink key={path} to={path} end={path === "/admin/"}
              style={({ isActive }) => ({
                display: "flex", alignItems: "center", gap: "10px",
                padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                textDecoration: "none", fontFamily: "Georgia, serif", fontSize: "13px",
                background:  isActive ? "#fff4ec" : "transparent",
                color:       isActive ? "#e07b39" : "#555",
                fontWeight:  isActive ? "700" : "400",
                borderLeft:  isActive ? "3px solid #e07b39" : "3px solid transparent",
                transition:  "all 0.15s",
              })}>
              <span style={{ fontSize: "15px" }}>{icon}</span> {label}
            </NavLink>
          ))}

        </div>

        {/* Admin user + logout */}
        <div style={{ padding: "16px", borderTop: "1px solid #f0ebe3" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
            <div style={{ width: "34px", height: "34px", borderRadius: "50%", background: "linear-gradient(135deg, #e07b39, #c96a18)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "700", flexShrink: 0 }}>
              {adminUser.username?.[0]?.toUpperCase() || "A"}
            </div>
            <div style={{ minWidth: 0 }}>
              <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "700", color: "#1a1a1a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{adminUser.username || "Admin"}</p>
              <p style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#aaa" }}>Super Admin</p>
            </div>
          </div>
          <button onClick={handleLogout}
            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1.5px solid #f0ebe3", background: "transparent", color: "#c0392b", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "600" }}>
            🚪 Log Out
          </button>
        </div>
      </div>

      {/* ── Main content ── */}
      <div style={{ flex: 1, overflowY: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}